var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNameMerge } from '@/lib/utils';
import * as React from 'react';
var defaultCardClasses = 'bg-white rounded-xl overflow-hidden shadow-lg flex border border-black/5 transition hover:shadow-xl duration-300';
var Card = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.testid, testid = _b === void 0 ? 'card' : _b, title = _a.title, props = __rest(_a, ["children", "className", "testid", "title"]);
    return (_jsx("div", __assign({ "aria-label": title, className: classNameMerge(className, defaultCardClasses), "data-testid": testid }, props, { ref: ref, children: _jsx("div", { className: classNameMerge('p-[24px] w-full'), "data-testid": "".concat(testid, "-content"), children: children }) })));
});
Card.displayName = 'Card';
export { Card, defaultCardClasses };
